import { makeAutoObservable } from 'mobx';
import { groupByFunction } from './utils/rxjs/groupByFunction';

export class UserPreferencesStore {
  root;
  userPreferences = {};

  constructor(root) {
    makeAutoObservable(this);
    this.root = root;
    this.initializeStream();
  }

  initializeStream = () => {
    this.userPreferencesSubject = groupByFunction(
      'messageType',
      'userPreferences',
      this.root.websocketSubject
    ).subscribe(msg => this.handleUserPreferences(msg));
  };

  handleUserPreferences = (msg) => {
    this.userPreferences = msg.json;
  }
}
